export const formatNumber = (num: number | undefined): string => (num ? String(num).replace('.', ',') : '0')
